import { render, staticRenderFns } from "./otherSaleChannelInfo.vue?vue&type=template&id=79eb8051&scoped=true"
import script from "./otherSaleChannelInfo.vue?vue&type=script&lang=js"
export * from "./otherSaleChannelInfo.vue?vue&type=script&lang=js"
import style0 from "./otherSaleChannelInfo.vue?vue&type=style&index=0&id=79eb8051&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eb8051",
  null
  
)

export default component.exports